<template lang="html">
  <div>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0 px-0">
          <l-map ref="map" v-resize="onResize" :style="{ height: 'calc(100vh - ' + (heightFloating - 80) + 'px)' }" :zoom="16" :center="center" class="z-index-1">
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker :lat-lng="markerLatLng" draggable @update:lat-lng="updateCoordinates" />
          </l-map>
          <div ref="section_floating" class="section-bottom z-index-2">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                  <div class="d-flex">
                    <v-spacer />
                    <v-btn height="40" width="40" min-width="40" class="mb-4 mr-4 br-5 ol-elevation-1" @click="getLatLng(true)">
                      <v-icon size="20">
                        mdi-crosshairs-gps
                      </v-icon>
                    </v-btn>
                  </div>
                  <div class="white sheet-map-addresss">
                    <div class="sheet-app-bar">
                      <div class="sheet-app-bar-content">
                        <div class="d-flex align-center">
                          <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                            <v-icon>
                              mdi-arrow-left
                            </v-icon>
                          </v-btn>
                          <div class="font-20 font-weight-bold">
                            {{ $t('v2.select_from_map') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-image mx-4 mb-2 pa-4 br-8 bg-grey">
                      <div class="flex-image-avatar mr-4 pa-2 white br-5">
                        <img src="@/assets/images/v2/img/icon_pin.png" alt="Pin maps">
                      </div>
                      <div class="flex-image-content">
                        <div class="flex-image-content-text font-14 ol-black font-weight-600">
                          {{ data_location.address }}
                        </div>
                      </div>
                    </div>
                    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
                      <div class="mx-4">
                        <div class="mb-1 font-12 font-weight-400 ol-black">
                          {{ $t('v2.location_name') }}
                        </div>
                        <ValidationProvider v-slot="{ errors }" name="location_name" rules="required">
                          <v-text-field v-model="data_location.name" outlined dense class="input-soft-border" :error-messages="errors" />
                        </ValidationProvider>
                      </div>
                      <div class="mx-4 mb-4">
                        <div class="mb-1 font-12 font-weight-400 ol-black">
                          {{ $t('v2.note_to_driver') }}
                        </div>
                        <v-textarea v-model="data_location.note" outlined height="62" hide-details class="input-soft-border text-area-v2" />
                      </div>
                      <div class="px-4 pb-8">
                        <v-btn block color="primary" height="40" class="text-none br-5" @click="saveLocation">
                          {{ $t('v2.save') }}
                        </v-btn>
                      </div>
                    </ValidationObserver>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import L from 'leaflet'
import { debounce } from 'debounce'
import {
  ValidationObserver
} from 'vee-validate'
import {
  // autoComplete as autoCompleteMaps,
  // placeDetail as placeDetailMaps,
  geoCodeByLatLng as geoCodeByLatLngMaps,
  distanceMatrix as distanceMatrixMaps
} from '@/api/maps'
export default {
  components: {
    ValidationObserver
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 15,
      center: [0, 0],
      markerLatLng: [0, 0],
      top_menu: 0,
      data_location: {
        name: '',
        note: '',
        address: '',
        lat: 0,
        lng: 0
      },
      locations: {
        history: [],
        name: '',
        driver_note: '',
        shipping_address: '',
        shipping_lat: 0,
        shipping_lon: 0,
        shipping_radius: 0
      }
    }
  },
  computed: {
    heightFloating() {
      return this.top_menu
    }
  },
  mounted() {
    const LOCAL_DATA_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
    if (LOCAL_DATA_LOCATION) {
      this.locations = JSON.parse(LOCAL_DATA_LOCATION)
    }
    this.getLatLng()
    this.top_menu = this.$refs.section_floating.clientHeight
  },
  methods: {
    goBack() {
      this.$router.push({ name: '_maps_search' }).catch(() => {})
    },
    async getLatLng(backTo = false) {
      if (!('geolocation' in navigator)) {
        console.log('Geolocation is not available.')
      }
      navigator.geolocation.getCurrentPosition(async(pos) => {
        if (backTo) {
          await this.$refs.map.setCenter([pos.coords.latitude, pos.coords.longitude])
          this.markerLatLng = L.latLng(pos.coords.latitude, pos.coords.longitude)
          this.getAddress({
            lat: pos.coords.latitude,
            lon: pos.coords.longitude
          })
        } else {
          if ((typeof this.locations.shipping_lat !== 'undefined' || typeof this.locations.shipping_lon !== 'undefined') && this.locations.shipping_lat !== 0 && this.locations.shipping_lon !== 0) {
            await this.$refs.map.setCenter([this.locations.shipping_lat, this.locations.shipping_lon])
            this.markerLatLng = L.latLng(this.locations.shipping_lat, this.locations.shipping_lon)
            this.getAddress({
              lat: this.locations.shipping_lat,
              lon: this.locations.shipping_lon
            })
          } else {
            await this.$refs.map.setCenter([pos.coords.latitude, pos.coords.longitude])
            this.markerLatLng = L.latLng(pos.coords.latitude, pos.coords.longitude)
            this.getAddress({
              lat: pos.coords.latitude,
              lon: pos.coords.longitude
            })
          }
        }
      }, () => {
        this.$store.state.block_location = true
      })
    },
    onResize() {
      this.$refs.map.mapObject._onResize()
    },
    async getAddress(point_map) {
      try {
        const { data } = await geoCodeByLatLngMaps(point_map)
        if (data.status === 'OK') {
          this.data_location.lat = point_map.lat
          this.data_location.lng = point_map.lon
          const i = data.results[0].address_components[0].types.findIndex((e) => {
            return e === 'plus_code'
          })
          if (i !== -1) {
            const arrAddress = data.results[0].formatted_address.split(', ')
            const x = arrAddress.findIndex((data_short) => {
              return data_short === data.results[0].address_components[0].short_name
            })
            arrAddress.splice(x, 1)
            this.data_location.address = arrAddress.join(', ')
          } else {
            this.data_location.address = data.results[0].formatted_address
          }
          this.data_location.name = this.locations.name
          this.data_location.note = this.locations.driver_note
        }
      } catch (e) {
        this.data_location.lat = 0
        this.data_location.lng = 0
        this.data_location.address = ''
        this.data_location.name = ''
        this.data_location.note = ''
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    updateCoordinates: debounce(async function(e) {
      this.getAddress({
        lat: e.lat,
        lon: e.lng
      })
      this.$refs.map.setCenter([e.lat, e.lng])
    }, 2000),
    async saveLocation() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        var select_store = this.$store.state.selected_store
        if (this.$store.state.selected_outlet) {
          select_store = this.$store.state.selected_outlet
        }
        const form = {
          origin_lat: Number(select_store.location_lat),
          origin_lon: Number(select_store.location_lon),
          destination: [
            {
              lat: this.data_location.lat,
              lon: this.data_location.lng
            }
          ]
        }
        const _this = this
        this.calcDistance(form).then(async(result) => {
          if (result.status === 'OK') {
            if (result.rows[0].elements[0].status === 'ZERO_RESULTS') {
              _this.$store.state.show_error = true
              _this.$store.state.error_message = this.$t('v2.check_your_location_again')
              _this.$store.state.error_type = 400
            // } else if (Math.ceil(result.rows[0].elements[0].distance.value / 1000) > select_store.delivery.max_radius_delivery) {
            //   _this.$store.state.show_error = true
            //   _this.$store.state.error_message = this.$t('v2.you_are_outside_the_store_delivery_limits')
            //   _this.$store.state.error_type = 400
            } else {
              _this.$set(_this.locations, 'name', _this.data_location.name)
              _this.$set(_this.locations, 'driver_note', _this.data_location.note)
              _this.$set(_this.locations, 'shipping_address', _this.data_location.address)
              _this.$set(_this.locations, 'shipping_lat', _this.data_location.lat)
              _this.$set(_this.locations, 'shipping_lon', _this.data_location.lng)
              _this.$set(_this.locations, 'shipping_radius', Math.ceil(result.rows[0].elements[0].distance.value / 1000))
              _this.$store.dispatch('saveLocationV2', _this.locations)
              _this.$router.push({ name: '_checkout' }).catch(() => {})
            }
          } else {
            _this.$store.state.show_error = true
            _this.$store.state.error_message = this.$t('v2.check_your_location_again')
            _this.$store.state.error_type = 400
          }
        })
      }
    },
    async calcDistance(dataDistance) {
      try {
        const { data } = await distanceMatrixMaps(dataDistance)
        if (data.status === 'ZERO_RESULTS') {
          this.$store.state.show_error = true
          this.$store.state.error_message = this.$t('v2.check_your_location_again')
          this.$store.state.error_type = 400
        } else {
          return data
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
